<template>
    <div class="tc-guide-item"
         :style="{'top': position[0], 'left': position[1]}">
        <SVGHelpArrowLeft v-if="side === 'left'"
                          style="width: 10px; height: 25px;"/>
        <div class="tc-guide-item-text">
            <div class="tc-div-contents" v-if="text">
                {{text}}
            </div>
            <div v-for="textItem in textArray">
                {{textItem}}
            </div>
        </div>
        <SVGHelpArrowRight v-if="side === 'right'"
                           style="width: 10px; height: 25px;"/>
    </div>
</template>

<script>
import SVGHelpArrowRight from '@/UI/SVG/SVGHelpArrowRight.vue';
import SVGHelpArrowLeft from '@/UI/SVG/SVGHelpArrowLeft.vue';

export default {
    name: 'GuideItem',
    components: { SVGHelpArrowLeft, SVGHelpArrowRight },
    props: [
        'text',
        'textArray',
        'side',
        'position',
    ],
};
</script>

<style scoped lang="scss">
.tc-guide-item {
    grid-template-columns: auto auto;
    display: grid;
    width: 330px;
    height: max-content;
    padding: 15px;
    box-sizing: border-box;
    flex-direction: row;
    grid-column-gap: 30px;
    justify-content: left;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    //pointer-events: none;
    background-color: #FFFFFF;

}

.tc-guide-item-text {
    font-size: 14px;
    color: #333333;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 15px;
}
</style>
